
import React, { useEffect, useMemo,useState } from 'react'
import { useLocation, useParams } from 'react-router'
import investorsImg from 'img/imgs/investors.svg'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './View.Style'
import * as pages from 'common_constants/Pages'
import { Link, useHistory } from 'react-router-dom'
import NavigationService from 'support/navigation/NavigationService'
import AddTeamMemberModal from './subcomponents/AddTeamMemberModal'
import ProfilePage from 'components_newui/profile/ProfilePage'
import { mapProfileResponse } from '../unifiedBenchProfile/BenchprofileMapper'

const BenchDetails = ({myEmail,match,isAdmin,
    classes, benchUserDisplayProfileResponse, getBenchUserDisplayProfileFn,
    myIdeasList, myIdeasLoading, addTeamMemberLoading,inviteTeamMemberLoading,
    getMyIdeasFn, addTeamMemberFn,inviteTeamMemberFn,onEditMyProfile,
    InnovateUserIdeasList,getInnovateUserIdeas
}) => {
    const { email = 'abc@abc.com' } = useParams()
    const [showAddTeamModal, setShowAddTeamModal] = useState(false)

const filteredDataMyIdeasList = useMemo(() => {
  return [...myIdeasList?.data || []].sort(
    (a, b) => (b?.created?.timestamp ?? 0) - (a?.created?.timestamp ?? 0)
  );
}, [myIdeasList]);

// console.log("filteredDataMyIdeasList==>", myIdeasList,filteredDataMyIdeasList)

    const history = useHistory()

// Utility function to clean "null" and empty strings
const sanitizeObject = (obj) => {
    const cleaned = {};
    Object?.entries(obj)?.forEach(([key, value]) => {
      cleaned[key] = value === "null" || value === "" ? null : value;
    });
    return cleaned;
  };
  
  const benchUserDisplayProfileResponse_user = sanitizeObject(benchUserDisplayProfileResponse);

 useEffect(() => {
      getMyIdeasFn()
  },[])
  
    useEffect(() => {
        if (email) {
            getBenchUserDisplayProfileFn(email)
            getInnovateUserIdeas(email)
        }
    }, [email])

  const { params, path } = match;
  // 1. Check if the user is looking at their own profile
  const isMe = path.toLowerCase().endsWith('/me') || params.email === myEmail;
  // 2. Fallback to myEmail if it is me, otherwise use the route param email
  const userEmail = isMe ? myEmail : params.email;
  // 3. Enable editing only if the target email belongs to the logged-in user
  const isEnableEditProfileButton = userEmail === myEmail;
  

  const ROUTES = NavigationService.getRoutes()
  const benchProfileUserMePath = ROUTES[pages.BENCHPROFILE].path.replace(":email", myEmail);

  // 2. Create the function
  const handleUpdateProfileClick = () => {
    // This replaces the <Link> component
    history.push({
      pathname: benchProfileUserMePath
    });
  };


    const ProfileResult = mapProfileResponse(benchUserDisplayProfileResponse_user);

    return (
        <div className={classes.container1}>

            <ProfilePage
                onEditProfile={handleUpdateProfileClick}
                onEditMyProfile={onEditMyProfile}
                InnovateUserIdeasList={InnovateUserIdeasList}
                classes={classes}
                isEnableEditProfileButton={isEnableEditProfileButton}
                benchProfileResponse={ProfileResult}
                handleAddToTeam={() => setShowAddTeamModal(true)}    
            />
            
            {/* Add Team Member Modal */}
            <AddTeamMemberModal
                isOpen={showAddTeamModal}
                isAdmin={isAdmin}
                onClose={() => setShowAddTeamModal(false)}
                userEmail={email}
                userName={benchUserDisplayProfileResponse_user?.name}
                myIdeasList={filteredDataMyIdeasList}
                myIdeasLoading={myIdeasLoading}
                addTeamMemberLoading={addTeamMemberLoading}
                inviteTeamMemberLoading={inviteTeamMemberLoading}
                onAddTeamMember={addTeamMemberFn}
                onInviteTeamMember={inviteTeamMemberFn}
                // getMyIdeasFn={getMyIdeasFn}
            />
        </div>
    )
}


export default withStyles(styles)(BenchDetails)
